import React, { useState } from 'react'
import Button from '@toasttab/shared/src/components/atoms/Button/Button'
import Image from '@toasttab/shared/src/components/atoms/Image/Image'
import Lock from '@toasttab/shared/src/components/atoms/DisplayIcon/Icons/Lock'
import { HiddenInfogramProps } from './HiddenInfogram.d'
import HiddenInfogramModal from './HiddenInfogramModal'
import HiddenInfogramMobileForm from './HiddenInfogramMobileForm'

const HiddenInfogram = ({
  ctaText,
  ctaTextMobile,
  entryId,
  formFieldset,
  formRedirectUrl,
  infogramImage,
  marketoFormId,
  marketoProgramName
}: HiddenInfogramProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleClick = () => {
    setIsModalOpen(!isModalOpen)
  }
  return (
    <section
      className='border border-color-light rounded-lg px-4 pt-3 pb-10 md:border-0 md:rounded-none md:px-0 md:py-0 relative'
      data-testid='HiddenInfogram'
    >
      <div className='relative'>
        <Image imageAlt='' url={infogramImage.file.url} />
        <Lock
          classes='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10 w-12 h-12 md:hidden'
          color='white'
        />
      </div>
      <div className='md:hidden mt-3'>
        <HiddenInfogramMobileForm
          ctaText={ctaTextMobile || ctaText}
          entryId={entryId}
          formFieldset={formFieldset}
          formRedirectUrl={formRedirectUrl}
          marketoFormId={marketoFormId}
          marketoProgramName={marketoProgramName}
        />
      </div>
      <Button
        classes='hidden md:flex font-semibold items-center !absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10 !border-0 !rounded-badge'
        data-testid='HiddenInfogram-button'
        onClick={handleClick}
        size='small'
        variation='secondary-outline-otl'
      >
        <span className='before:content-icon-lock before:mr-2 flex items-center'>
          {ctaText}
        </span>
      </Button>
      <HiddenInfogramModal
        entryId={entryId}
        formFieldset={formFieldset}
        formRedirectUrl={formRedirectUrl}
        handleClose={handleClick}
        isOpen={isModalOpen}
        marketoFormId={marketoFormId}
        marketoProgramName={marketoProgramName}
      />
    </section>
  )
}

export default HiddenInfogram
